import React, { useReducer } from "react";
// import "./style.css";
import { Col, Container, Row } from "react-bootstrap";

const INITIAL_STATE = {
  name: "",
  email: "",
  subject: "",
  message: "",
  status: "IDLE",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "updateFieldValue":
      return { ...state, [action.field]: action.value };
    case "updateStatus":
      return { ...state, status: action.status };
    case "reset":
    default:
      return INITIAL_STATE;
  }
};

const Form = ({ isVisible }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  const updateFieldValue = (field) => (event) => {
    dispatch({ type: "updateFieldValue", field, value: event.target.value });
  };

  const setStatus = (status) => {
    debugger;
    dispatch({ type: "updateStatus", status });
  };

  const handleSubmit = (event) => {
    debugger;
    event.preventDefault();
    setStatus("PNEDING", () => console.log("state"));
    console.log(state);

    fetch("/api/contact", { method: "POST", body: JSON.stringify(state) })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        console.log("SUCCESS");
        setStatus("SUCCESS");
      })
      .catch((error) => {
        console.error(error);
        setStatus("ERROR");
      });
  };

  if (isVisible) {
    if (state.status === "SUCCESS") {
      return (
        <h1 className="heading" style={{ marginBottom: "30px" }}>
          Message sent
        </h1>
      );
    } else
      return (
        <>
          <Container style={{ border: "1px solid mediumseagreen" }}>
            <Row>
              <Col>
                <h1 className="heading" style={{ marginBottom: "15px" }}>
                  Send me a message
                </h1>
              </Col>
            </Row>
            <form
              className="flexbox"
              style={{ alignItems: "flex-start" }}
              onSubmit={handleSubmit}
            >
              <Container style={{ marginTop: "0px" }}>
                <Row>
                  <Col>
                    <div className="group">
                      <input
                        type="text"
                        required
                        value={state.name}
                        onChange={updateFieldValue("name")}
                      />
                      <span className="highlight"></span>
                      <span className="bar"></span>
                      <label>Name</label>
                    </div>
                  </Col>
                  <Col>
                    <div className="group">
                      <input
                        type="text"
                        required
                        value={state.email}
                        onChange={updateFieldValue("email")}
                      />
                      <span className="highlight"></span>
                      <span className="bar"></span>
                      <label>Email</label>
                    </div>
                  </Col>
                  <Col>
                    <div className="group">
                      <input
                        type="text"
                        required
                        value={state.subject}
                        onChange={updateFieldValue("subject")}
                      />
                      <span className="highlight"></span>
                      <span className="bar"></span>
                      <label>Subject</label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="group">
                      <div>
                        <label
                          style={{
                            position: "static",
                            left: "0px",
                            top: "0px",
                          }}
                        >
                          Message
                        </label>
                      </div>
                      <div style={{}}>
                        <textarea
                          style={{
                            minWidth: "50vw",
                            maxWidth: "100%",
                            border: "1px solid seagreen",
                          }}
                          rows="5 "
                          // cols="50"
                          type="text"
                          required
                          value={state.message}
                          onChange={updateFieldValue("message")}
                        />
                      </div>
                      <span className="highlight"></span>
                      <span className="bar"></span>
                    </div>
                  </Col>
                </Row>

                <button>Send</button>
              </Container>
            </form>
          </Container>
        </>
      );
  } else {
    return null;
  }
};

export default Form;
